import { useViewport } from 'hooks/3catinfo/useViewport';
import Titol from 'components/3catinfo/Titol';
import Compartir from 'components/3catinfo/Compartir';
import styles from './capcaleraTemps.module.scss';
import CercaMunicipi from 'components/3catinfo/ElTemps/CercaMunicipi';
import clsx from 'clsx';

const getSeason = () => {
    const dataActual = new Date();
    const dia = dataActual.getDate();
    const mes = dataActual.getMonth() + 1;

    if ((mes === 12 && dia >= 21) || mes === 1 || mes === 2 || (mes === 3 && dia < 21)) {
        return 'hivern';
    } else if ((mes === 3 && dia >= 21) || mes === 4 || mes === 5 || (mes === 6 && dia < 21)) {
        return 'primavera';
    } else if ((mes === 6 && dia >= 21) || mes === 7 || mes === 8 || (mes === 9 && dia < 21)) {
        return 'estiu';
    } else {
        return 'tardor';
    }
};

const CapcaleraTemps = (props) => {
    const { mostraAccions, tag, titol, compartir, estacions } = props;
    const { zoomNavigator } = useViewport();
    const season = getSeason();
    const imatgeEstacio = estacions?.[season];

    const stylesContentShared = clsx({
        [styles.contentShared]: true,
        [styles.ambZoom]: zoomNavigator > 3
    });

    return (
        <div className={styles.capcalera} style={{ backgroundImage: `url(${imatgeEstacio})` }}>
            <div className={styles.capcaleraWrapper}>
                <div className={styles.titolWrapper}>
                    <Titol tag={tag} titol={titol} tipus='seccio' />
                    {mostraAccions && (
                        <div className={stylesContentShared}>
                            <CercaMunicipi placeholder='Cerca per municipi' inputId='search-capcalera'></CercaMunicipi>
                            <div>{compartir && <Compartir obreEsquerra={zoomNavigator > 2} />}</div>
                        </div>
                    )}
                </div>
                <div className={styles.imageWrapper} style={{ backgroundImage: `url(${imatgeEstacio})` }}></div>
            </div>
        </div>
    );
};

CapcaleraTemps.defaultProps = {
    mostraAccions: true,
    compartir: true
};

export default CapcaleraTemps;
